const ExportSideBar = {
  minWidth: 435,
  width: 435,
  zIndex: 0,
  position: 'relative',
  top: 108,
  overflow: 'hidden auto'
}

export default {
  ExportSideBar,
  DeviceSideBar: {
    ...ExportSideBar,
    top: 0,
    height: 'auto'
  }
}



// WEBPACK FOOTER //
// ./src/components/SideBar/exportStyle.js